import {AppState} from "../index";
import {createSelector} from "reselect";
import {IUser} from "./types";

export const selectCurrentUser = (state: AppState) => state.user.currentUser

export const createSelectCurrentUserWithCondition = (state: AppState, condition: any) => createSelector([selectCurrentUser], (currentUser): IUser | null => {
    if (condition(currentUser)) {
        return currentUser as IUser
    }
    return null

})(state)